export default {
  tedy: [],
  reactions: [],
  follow: [],
  random: {},
  posts: [],
  randomFriends: [],
  notifications: [],
  productDeletionPending: [],
  // test
  productCreationPending: false,
};
